import * as React from 'react';
import styled from 'styled-components';
import { rem } from 'polished';
import { FlexRowCenterVertical } from '../../Defaults/Flexbox/Flexbox';
import { TextP } from '../../Defaults/Text';

interface Props {
  title: string;
  value: string;
  hasBorderTop?: boolean;
}

function InfoRow({ title, value, hasBorderTop }: Props) {
  return (
    <Row hasBorderTop={hasBorderTop}>
      <Title>{title}</Title>
      <Value>{value}</Value>
    </Row>
  );
}

const Row = styled(FlexRowCenterVertical)<{ hasBorderTop?: boolean }>`
  padding: ${rem(16)} 0;
  justify-content: space-between;
  border-bottom: ${({ theme }) => theme.borders.primary};
  border-top: ${({ theme, hasBorderTop }) =>
    hasBorderTop ? theme.borders.primary : 0};
  margin: 0;
`;

const Text = styled(TextP)`
  font-size: ${rem(14)};
  font-weight: 300;
  line-height: ${rem(22)};
`;

const Title = styled(Text)`
  color: ${({ theme }) => theme.colors.placeholder};
  margin-right: ${rem(8)};
`;

const Value = styled(Text)`
  color: black;
`;

export default InfoRow;
